import { Flex, Skeleton } from '@iheartjane/reefer';

import { useKioskSpacing } from '@jane/kiosk/hooks';

import { productCardMaxWidth, productCardMinWidth } from './ProductCard';

export const ProductCardSkeleton = () => {
  const { getKioskSpacing, isIpad } = useKioskSpacing();
  return (
    <Skeleton animate>
      <Flex
        flexDirection="column"
        justifyContent="center"
        minWidth={productCardMinWidth}
        maxWidth={productCardMaxWidth}
        mx="auto"
        width="100%"
      >
        <Skeleton.Bone
          height={isIpad ? '235px' : '300px'}
          mb={getKioskSpacing(24, 16)}
        />
        <Skeleton.Bone width="50%" mx={16} my={8} />
        <Skeleton.Bone width="85%" mx={16} my={8} />
        <Skeleton.Bone width="65%" mx={16} my={8} />
        <Skeleton.Bone width="25%" mx={16} mt={8} />
      </Flex>
    </Skeleton>
  );
};
